'use client'

import { Navigation, SushiNavigationDropdown } from '@sushiswap/ui'
import React, { type FC } from 'react'
import { headerElements } from 'src/app/_common/header-elements'
import { WagmiHeaderComponents } from 'src/lib/wagmi/components/wagmi-header-components'

export const Header: FC = () => {
  return (
    <div className="w-full h-[56px] z-20">
      <div className="fixed w-full flex z-20">
        <div className="hidden lg:flex justify-between items-center px-1 h-14 flex-shrink-0 border-transparent border-b">
          <SushiNavigationDropdown className="!px-2">
            <span className="inline-flex items-center">
              <img
                src="/katan_swap_logo_ink.svg"
                alt="Katana"
                className="h-[26px] w-auto block dark:hidden black:hidden"
              />
              <img
                src="/katan_swap_logo_spark.svg"
                alt="Katana"
                className="h-[26px] w-auto hidden dark:block black:block"
              />
            </span>
          </SushiNavigationDropdown>
        </div>
        <div className="flex lg:hidden justify-between items-center pl-4 border-transparent border-b">
          <SushiNavigationDropdown>
            <span className="inline-flex items-center">
              <img
                src="/katan_swap_logo_ink.svg"
                alt="Katana"
                className="h-6 w-auto block dark:hidden black:hidden"
              />
              <img
                src="/katan_swap_logo_spark.svg"
                alt="Katana"
                className="h-6 w-auto hidden dark:block black:block"
              />
            </span>
          </SushiNavigationDropdown>
        </div>
        <Navigation
          className="!pl-0 lg:!pl-4 !z-[unset] !bg-[unset] dark:!bg-[unset] !border-transparent dark:!border-transparent"
          hideSushiDropdown
          leftElements={headerElements()}
          rightElement={<WagmiHeaderComponents />}
        />
      </div>
    </div>
  )
}
